import { useState, useMemo, useEffect } from "react";
import Swal from "sweetalert2";
import StudentTemplate from "../../component/StudentTemplate";
import Select from "react-select";
import Api from "../../component/Api";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import CreatableSelect from "react-select/creatable";


const StudentInternship = () => {
  const [selectedCourse, setSelectedCourse] = useState('');
  const [isNotListed, setIsNotListed] = useState(false);
  const [internshipData, setInternshipData] = useState([]);
  const [studentDisciplineName, setStudentDisciplineName] = useState("");
  const [flag, setflag] = useState(false);
  const [selectedInternship, setSelectedInternship] = useState(null);
  const [internshipStudentData, setInternshipStudentData] = useState({});
  const [getActiveEvents, setActiveEvents] = useState(null);
  const [eventMessage, setEventMessage] = useState("");
  const [isEventActive, setIsEventActive] = useState(false);
  const [isFirstSubmit, setFirstSubmit] = useState(false);
  const [isFirstSubmitExt, setFirstSubmitExt] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [savedInternship, setSavedInternship] = useState(null);
  const [isFormLocked, setIsFormLocked] = useState(false);
  const [internshipType, setInternshipType] = useState(null);
  const [selectedInternshipType, setSelectedInternshipType] = useState(null);
  const [showUpdateMode, setShowUpdateMode] = useState(false);
  const [courseCode, setCourseCode] = useState(null);
  const [courseName, setCourseName] = useState(null);
  const [externalInternship, setExternalInternship] = useState({
    title: "",
    provider: "",
    provider_name: "",
    duration: "",
    mode: "",
    description: ""
  });
  const [activeReadOnlyMode, setActiveReadOnlyMode] = useState(false);
  const [activeReadOnlyMessage, setActiveReadOnlyMessage] = useState("");
  const [getVendorData, setVendorData] = useState([]);


  // NEW STATE
  const [internshipSource, setInternshipSource] = useState("");
  const [isIPO, setIsIPO] = useState(false);
  const ipoProviders = ["Keltron", "ASAP"];

  let cid = localStorage.getItem("collegeid");
  let student_scheme_id = localStorage.getItem("scheme_id");

  const { http } = Api();
  const navigate = useNavigate();

  const formatDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";

    const [datePart, timePart] = dateTimeStr.split(" ");
    const [year, month, day] = datePart.split("-");
    let [hours, minutes, seconds] = timePart.split(":");

    let period = "AM";
    hours = Number(hours);

    if (hours >= 12) {
      period = "PM";
      if (hours > 12) hours -= 12;
    }
    if (hours === 0) hours = 12;

    return `${day}-${month}-${year} ${hours
      .toString()
      .padStart(2, "0")}:${minutes}:${seconds} ${period}`;
  };


  {/* Check for course code and IS mapped student */ }
  useEffect(() => {
    if (Object.keys(internshipStudentData).length === 0) return;

    // CASE 1: No internship course
    if (!internshipStudentData?.course_code) {
      const msg = "You have not registered for the internship course in the course selection.";

      setActiveReadOnlyMode(true);
      setActiveReadOnlyMessage(msg);

      toast.warning(msg, {
        className: "toast-warning",
        autoClose: 5000
      });
    }

    // CASE 2: Supervisor not mapped
    else if (!internshipStudentData?.iso_mapped_accountid) {
      const msg = "Internship Supervisor (IS) is not mapped to your profile. Please contact your college.";

      setActiveReadOnlyMode(true);
      setActiveReadOnlyMessage(msg);

      toast.warning(msg, {
        className: "toast-warning",
        autoClose: 5000
      });
    }

    // CASE 3: Valid data
    else {
      setCourseCode(internshipStudentData.course_code);
      setCourseName(internshipStudentData.course_name);
      setActiveReadOnlyMode(false);
      setActiveReadOnlyMessage("");
    }

  }, [internshipStudentData]);
  {/* Check for course code and IS mapped student End */ }

  useEffect(() => {
    const fetchInternshipData = async () => {
      http.get('/College/listTopicstudent')
        .then((response) => {
          if (response.data.status_code === 'ERR5') {
            setflag(true);
          }

          if (Array.isArray(response.data?.data)) {
            setInternshipData(response.data.data);
            setStudentDisciplineName(response.data.student.discipline_name);
            setInternshipStudentData(response.data.student);
          } else {
            setInternshipData([]);
            setStudentDisciplineName("null");
          }
        }).catch((error) => {
          setInternshipData([]);
          setStudentDisciplineName("null");

          const err = error.response?.data;
          if (err?.http_status === 401 && err?.status_code === 'ERR9') {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/"), 5000);
          } else if (err?.http_status === 429 && err?.status_code === 'ERR33') {
            toast.error(err.message);
          } else {
            toast.error("Something went wrong");
          }
        });
    };

    fetchInternshipData();
  }, [reload]);

  useEffect(() => {
    if (!getActiveEvents) return;

    http.get("/College/getsavedInternshipTopic")
      .then((response) => {
        if (response.data?.status_code !== "MSG3") return;

        const saved = response.data.data;

        if (!saved || saved.length === 0) {
          toast.info("No saved internship application found for the current semester.");
          return;
        }

        setSavedInternship(saved);
        setInternshipType(saved.type);
        setSelectedInternshipType(saved.internship_type);

        // Check if update is allowed (event is active)
        const canUpdate = isEventActive;

        // Lock statuses
        const lockedStatuses = ["principal_approved", "iso_forwarded", "ino_forwarded"];
        setIsFormLocked(lockedStatuses.includes(saved.entry_status));

        // Initially show in view mode
        setShowUpdateMode(false);

        // Populate data based on type
        if (saved.type === "internal") {
          setIsNotListed(false);
          setInternshipSource("COLLEGE");
          setSelectedCourse(saved.topic_id);
          setSelectedInternship({
            id: saved.topic_id,
            internship_topic: saved.internship_topic,
            mode_of_study: saved.mode_of_study,
            offered_by_name: saved.vendor_name,
            vendor_mobileno: saved.vendor_mobileno,
            vendor_email: saved.vendor_email,
            vendor_address: saved.vendor_address,
            description: saved.description
          });
        }

        if (saved.type === "external") {
          setIsNotListed(true);
          setSelectedCourse("EXTERNAL_LOCKED");

          if (ipoProviders.includes(saved.external_ipo_name)) {
            setIsIPO(true);
            setInternshipSource("IPO");
          } else {
            setIsIPO(false);
            setInternshipSource("NOT_LISTED");
          }

          setExternalInternship({
            title: saved.external_topic_name || "",
            provider: saved.external_ipo_id || "",
            provider_name: saved.external_ipo_name || "",
            duration: saved.external_ipo_duration || "",
            mode: saved.mode_of_study || "",
            description: saved.external_ipo_description || ""
          });
        }
      })
      .catch((error) => {

        const status = error.response?.status;
        const errorCode = error.response?.data?.status_code;
        const message = error.response?.data?.message || "Something went wrong";

        if (message.includes('Attempt to read property "user_id"') ||
          (status === 500 && message.includes("user_id"))) {
          toast.error("Session expired. Please log in again.");
          setTimeout(() => navigate("/"), 3000);
        } else if (status === 403 && errorCode === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/"), 3000);
        } else {
          toast.error(message);
        }
      });
    // }, [getActiveEvents, reload, isEventActive]);
  }, [getActiveEvents, reload]);


  useEffect(() => {
    const fetchActiveEvents = async () => {
      try {
        const response = await http.get('getActiveEvents', {
          params: { event_id: 33 }
        });

        const events = Array.isArray(response.data) ? response.data : [response.data];
        const matchedEvent = events.find(event =>
          Number(event.admission_year) === Number(internshipStudentData.admissionyear) &&
          Number(event.semester_id) === Number(internshipStudentData.currentsemester) &&
          event.status === "active" &&
          event.scheme_id === Number(student_scheme_id)
        );

        if (matchedEvent) {
          setActiveEvents(matchedEvent);
          setIsEventActive(true);
          setEventMessage(
            `Internship application window is open. Please submit your application on or before ${formatDateTime(matchedEvent.end_date)}.`
          );
        } else {
          setActiveEvents(null);
          setIsEventActive(false);
          setEventMessage("The internship application date is currently closed.");
        }
      } catch (error) {
        setActiveEvents(null);
        setIsEventActive(false);
        setEventMessage("");

        const message = error.response?.data?.message || "An error occurred";
        const status = error.response?.status;
        const errorCode = error.response?.data?.status_code;

        if (message.includes('Attempt to read property "user_id"') ||
          (status === 500 && message.includes('user_id'))) {
          toast.error("Session expired. Please log in again.");
          setTimeout(() => navigate("/"), 3000);
        } else if (status === 403 && errorCode === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/"), 3000);
        } else {
          toast.error(message);
        }
      }
    };

    if (internshipStudentData.admissionyear && internshipStudentData.currentsemester) {
      fetchActiveEvents();
    }
  }, [internshipStudentData.admissionyear, internshipStudentData.currentsemester]);

  const handleUpdateClickq = () => {
    setShowUpdateMode(true);
    //setIsFormLocked(false); // Enable editing in update mode
    setInternshipSource(savedInternship.internship_type);
  };
  const handleUpdateClick = () => {
    setShowUpdateMode(true);

    const type = savedInternship.internship_type;
    setInternshipSource(type);

    if (type === "COLLEGE") {
      setIsIPO(false);
      setIsNotListed(false);
    }

    if (type === "IPO") {
      setIsIPO(true);
      setIsNotListed(true);
    }

    if (type === "NOT_LISTED") {
      setIsIPO(false);
      setIsNotListed(true);
    }
  };

  {/* for get UniversityAddedVendor list */ }
  useEffect(() => {

    const UniversityAddedVendor = () => {

      http.get(`/College/UniversityAddedVendor`)
        .then((response) => {
          // console.log("res", response.data.data);
          setVendorData(response.data.vendors);
        })
        .catch((error) => {
          setVendorData([]);
          const err = error.response?.data;

          if (err?.http_status === 401 && err?.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/");
            }, 5000);

          } else if (err?.http_status === 429 && err?.status_code === "ERR33") {
            toast.error(err.message);

          } else {
            toast.error("Something went wrong");
          }
        });
    };

    UniversityAddedVendor();

  }, []);
  {/* for get UniversityAddedVendor list end */ }

  const handleFinalSubmit = () => {
    //if (!validateExternalForm()) return;

    if (!selectedInternship) return;

    setLoading(true);

    http.post("/College/saveInternshipTopic", {
      topic_id: selectedInternship.id,
      mode_of_study: selectedInternship.mode_of_study,
      type: 'internal',
      internship_type: internshipSource
    })
      .then((response) => {
        if (response.data.status_code === "MSG3" || response.status === 200) {
          toast.success("Internship updated successfully!");
          setFirstSubmit(false);
          setShowUpdateMode(false);
          setReload(!reload);
        }
      })
      .catch((error) => {
        const status = error.response?.data?.http_status;
        if (status === 403) {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/"), 3000);
        } else {
          toast.error("Failed to update internship");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancel = () => {
    setFirstSubmit(false);
  };
  const cancelForm = () => {
    window.location.reload();
  };

  {/* values saved from input controlls */ }
  const handleExternalChange = (e) => {
    const { name, value } = e.target;

    setExternalInternship((prev) => {

      // PROVIDER FIELD
      if (name === "provider") {

        // IPO (Dropdown)
        if (isIPO) {
          const selectedVendor = getVendorData.find(v => v.id == value);

          return {
            ...prev,
            provider: value,
            provider_name: selectedVendor?.vendor_name || ""
          };
        }

        // NOT LISTED (Text Input)
        return {
          ...prev,
          provider: value,        // store text also here if needed
          provider_name: value    // important for input display
        };
      }

      // OTHER FIELDS
      return {
        ...prev,
        [name]: value
      };
    });
  };

  const validateExternalForm = () => {
    if (!externalInternship.title?.trim()) {
      toast.error("Please enter Internship Title");
      return false;
    }
    // if (!externalInternship.provider?.trim()) {
    //   toast.error("Please enter Internship Provider");
    //   return false;
    // }

    if (isIPO) {
      // dropdown (ID)
      if (!externalInternship.provider) {
        toast.error("Please select Internship Provider");
        return false;
      }
    } else {
      // text input
      if (!externalInternship.provider?.trim()) {
        toast.error("Please enter Internship Provider");
        return false;
      }
    }
    // if (!externalInternship.duration) {
    //   toast.error("Please select Internship Duration");
    //   return false;
    // }
    if (!externalInternship.mode) {
      toast.error("Please select Mode of Internship");
      return false;
    }
    return true; // all validations passed
  };
  const setFirstSubmitData = () => {
    if (!validateExternalForm()) return;
    setFirstSubmitExt(true);
  };

  const handleFinalSubmitExt = () => {
    setLoading(true);

    const payload = {
      topic_id: null,
      type: 'external',
      internship_type: internshipSource,
      external_topic_name: externalInternship.title,
      external_ipo_id: externalInternship.provider,
      external_ipo_name: externalInternship.provider_name,
      external_ipo_duration: externalInternship.duration,
      mode_of_study: externalInternship.mode,
      external_ipo_description: externalInternship.description
    };

    http.post("/College/saveInternshipTopic", payload)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Internship updated successfully");
          setFirstSubmitExt(false);
          setShowUpdateMode(false);
          setReload(!reload);
        }
      })
      .catch(() => {
        toast.error("Failed to update internship");
      })
      .finally(() => setLoading(false));
  };

  const handleCancelExt = () => {
    setFirstSubmitExt(false);
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "10px",
      border: "1px solid",
      borderColor: state.isFocused ? "#782849" : "#cfcfcf",
      backgroundColor: "#f5f5f5",
      minHeight: "48px",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(120, 40, 73, 0.2)"
        : "none",
      transition: "all 0.2s ease",

      "&:hover": {
        borderColor: "#782849",
      },
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "6px 12px",
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#666",
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#000",
      fontWeight: 500,
    }),

    indicatorSeparator: () => ({
      display: "none", // cleaner like your UI
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: "#333",
      transition: "0.2s",
      transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "none",
    }),

    menu: (provided) => ({
      ...provided,
      borderRadius: "10px",
      overflow: "hidden",
      marginTop: "6px",
    }),

    option: (provided, state) => ({
      ...provided,
      padding: "10px 14px",
      backgroundColor: state.isSelected
        ? "#e8d6dd"
        : state.isFocused
          ? "#f2e7ec"
          : "#fff",
      color: "#222",
      cursor: "pointer",
    }),
  };

  const formatOption = (item) => ({
    value: item.id,
    label: `${item.internship_topic} ${item.offered_by_name}`, // ✅ searchable
    topic: item.internship_topic,
    provider: item.offered_by_name,
  });

  const ipoOptions = [
    { value: "COLLEGE", label: "College Enlisted" },
    { value: "IPO", label: "University Enlisted" },
    { value: "NOT_LISTED", label: "Others" },
  ];


  useEffect(() => {
    if (savedInternship) {
      setInternshipSource(savedInternship.internship_type);
    }
  }, [savedInternship]);
  // Render saved internship view
  const renderSavedInternship = () => {
    if (!savedInternship) return null;

    const getStatusClass = (status) => {
      const statusMap = {
        'entered': 'entered',
        'principal_approved': 'principal_approved',
        'principal_reverted': 'principal_reverted',
        'iso_forwarded': 'iso_forwarded',
        'iso_reverted': 'iso_reverted',
        'ino_forwarded': 'ino_forwarded',
        'ino_reverted': 'ino_reverted',
      };
      return statusMap[status] || '';
    };
    const getStatusLabel = (status) => {
      const labelMap = {
        'entered': 'Entered',
        'principal_approved': 'Principal Approved',
        'principal_reverted': 'Principal Reverted',
        'iso_forwarded': 'IS Forwarded',
        'iso_reverted': 'IS Reverted',
        'ino_forwarded': 'INO Forwarded',
        'ino_reverted': 'INO Reverted',

      };
      return labelMap[status] || status;
    };

    return (
      <div className={`card details-card saved-card ${!showUpdateMode ? '' : 'edit-mode'}`}>
        <div className="badge-group" style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          <span className={`status-badge ${savedInternship.type}`}>
            {savedInternship.type === 'internal' ? '🏢 Internal' : '🌐 External'}
          </span>
          <span className={`status-badge ${getStatusClass(savedInternship.entry_status)}`}>
            Status: {getStatusLabel(savedInternship.entry_status)}
          </span>
          {/* {courseCode && (
            <span className="course-code-badge">
              Course Code: {courseCode}-{courseName}
            </span>
          )} */}
        </div>

        {!showUpdateMode ? (
          // VIEW MODE - Show details without form controls
          <>
            {/* {(internshipSource || savedInternship.internship_type) === "COLLEGE" ? ( */}
            {/* New code added */}
            {savedInternship.type === 'internal' ? (
              <>
                <h3 className="m-10">
                  {savedInternship.internship_topic}
                  {courseCode && <span className="course-code-badge">Course Code: {courseCode}-{courseName}</span>}
                </h3>

                <div className="row info-grid-bs">
                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Offered By</label>
                      <span>{savedInternship.vendor_name}</span>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Mode of Study</label>
                      <span>{savedInternship.mode_of_study}</span>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Vendor Mobile</label>
                      <span>{savedInternship.vendor_mobileno}</span>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Vendor Email</label>
                      <span>{savedInternship.vendor_email}</span>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="info-item">
                      <label>Vendor Address</label>
                      <span style={{ whiteSpace: "pre-line" }}>
                        {savedInternship.vendor_address}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              // External view mode
              <>
                <h3>
                  Internship Details
                  {courseCode && <span className="course-code-badge">Course: {courseCode}-{courseName}</span>}
                </h3>

                <div className="row info-grid-bs">
                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Internship Title</label>
                      <span>{savedInternship.external_topic_name}</span>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Provider </label>
                      <span>{savedInternship.external_ipo_name}</span>
                    </div>
                  </div>
                  {/* Duration hide */}
                  {/* <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Duration</label>
                      <span>{savedInternship.external_ipo_duration} Months</span>
                    </div>
                  </div> */}

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Mode</label>
                      <span>{savedInternship.mode_of_study}</span>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="info-item">
                      <label>Description</label>
                      <span>{savedInternship.external_ipo_description || 'N/A'}</span>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Update button - only show if event is active */}
            {isEventActive && !isFormLocked && (
              <div className="actions actions-right">
                <button
                  className="btn-update"
                  onClick={handleUpdateClick}
                >
                  Update Internship
                </button>
              </div>
            )}

            {/* Note about update availability */}
            {isEventActive && !isFormLocked && (
              <div className="update-note">
                You can update your internship application until {formatDateTime(getActiveEvents?.end_date)}
              </div>
            )}

            {isFormLocked && (
              <p className="text-center text-danger mt-3">
                This internship submission has already been forwarded/approved and cannot be edited.
              </p>
            )}

            {!isEventActive && !isFormLocked && (
              <p className="text-center text-warning mt-3">
                The application window is closed. No further updates are allowed.
              </p>
            )}
          </>
        ) : (
          // UPDATE MODE - Show editable form
          <>
            {/* {savedInternship.type === 'internal' ? ( */}

            {/* New code added */}
            {(internshipSource || savedInternship.internship_type) === "COLLEGE" ? (
              <>
                <h3>Update Internship Details: {savedInternship.internship_topic}</h3>
                <p>Select Internship Providing Organisation(IPO) <span className="errorclr">*</span></p>

                {/* FIRST SELECT BOX */}

                <Select
                  styles={customStyles}
                  options={ipoOptions}
                  value={
                    ipoOptions.find(
                      (opt) =>
                        opt.value === (internshipSource || savedInternship.internship_type)
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    const value = selectedOption?.value || "";

                    // KEEP YOUR ORIGINAL LOGIC EXACTLY
                    setInternshipSource(value);

                    if (value === "COLLEGE") {
                      setIsNotListed(false);
                      setIsIPO(false);
                    }

                    if (value === "IPO") {
                      setIsIPO(true);
                      setIsNotListed(true);
                    }

                    if (value === "NOT_LISTED") {
                      setIsIPO(false);
                      setIsNotListed(true);
                    }
                  }}
                  placeholder="--- Select ---"
                  isClearable
                />

                <p>Select Internship Topic <span className="errorclr">*</span></p>
                {/* {(internshipSource || savedInternship.internship_type) === "COLLEGE" && ( */}

                {/* New code added */}
                {internshipSource === "COLLEGE" && (

                  <>
                    <div className="m-b-20">
                      <Select
                        styles={customStyles}
                        options={internshipData.map(formatOption)}
                        value={
                          selectedCourse
                            ? internshipData
                              .map(formatOption)
                              .find((opt) => opt.value === Number(selectedCourse))
                            : null
                        }
                        onChange={(selectedOption) => {
                          const value = selectedOption?.value || "";

                          // ✅ KEEP YOUR ORIGINAL LOGIC
                          setSelectedCourse(value);

                          const internship = internshipData.find(
                            (item) => item.id === Number(value)
                          );

                          setSelectedInternship(internship || null);
                        }}
                        placeholder="-- Select Course --"
                        isClearable

                        //Option value last part styling
                        formatOptionLabel={(option) => (
                          <div style={{ display: "flex", gap: "6px" }}>
                            <span>{option.topic}</span>
                            <span style={{ color: "#782849", fontWeight: 500 }}>
                              | {option.provider}
                            </span>
                          </div>
                        )}
                      />
                    </div>


                    {selectedInternship && (
                      <div className="row info-grid-bs">
                        <div className="col-12 col-md-6 mb-3">
                          <div className="info-item">
                            <label>Offered By</label>
                            <span>{selectedInternship.offered_by_name}</span>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 mb-3">
                          <div className="info-item">
                            <label>Mode of Study</label>
                            <select
                              value={selectedInternship.mode_of_study}

                              //disabled={!!selectedInternship.mode_of_study}
                              onChange={(e) =>
                                setSelectedInternship({
                                  ...selectedInternship,
                                  mode_of_study: e.target.value
                                })
                              }
                            >
                              <option value="Online">Online</option>
                              <option value="Offline">Offline</option>
                              <option value="Hybrid">Hybrid</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 mb-3">
                          <div className="info-item">
                            <label>Vendor Mobile</label>
                            <span>{selectedInternship.vendor_mobileno}</span>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 mb-3">
                          <div className="info-item">
                            <label>Vendor Email</label>
                            <span>{selectedInternship.vendor_email}</span>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="info-item">
                            <label>Vendor Address</label>
                            <span>{selectedInternship.vendor_address}</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}

                <div className="actions actions-right">
                  <button
                    className="btn-secondary"
                    onClick={() => {
                      setShowUpdateMode(false);
                      setReload(!reload);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn-primary"
                    onClick={() => setFirstSubmit(true)}
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update"}
                  </button>
                </div>
              </>
            ) : (
              // External update mode
              <>
                <h3>Update Internship Details</h3>

                {/* EXTERNAL / IPO FORM */}

                {/* FIRST SELECT BOX */}
                <p>Select Internship Providing Organisation(IPO) <span className="errorclr">*</span></p>


                <Select
                  styles={customStyles}
                  options={ipoOptions}
                  value={
                    ipoOptions.find(
                      (opt) =>
                        opt.value === (internshipSource || savedInternship.internship_type)
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    const value = selectedOption?.value || "";

                    // ✅ KEEP YOUR ORIGINAL LOGIC EXACTLY
                    setInternshipSource(value);

                    // RESET EXTERNAL FORM
                    setExternalInternship({
                      title: "",
                      provider: "",
                      provider_name: "",
                      duration: "",
                      description: "",
                      mode: "",
                    });

                    setSelectedCourse("");
                    setSelectedInternship(null);

                    if (value === "COLLEGE") {
                      setIsIPO(false);
                      setIsNotListed(false);
                    }

                    if (value === "IPO") {
                      setIsIPO(true);
                      setIsNotListed(true);
                    }

                    if (value === "NOT_LISTED") {
                      setIsIPO(false);
                      setIsNotListed(true);
                    }
                  }}
                  placeholder="--- Select ---"
                  isClearable
                />
                {internshipSource === "COLLEGE" && (
                  <>
                    <select
                      value={selectedCourse}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedCourse(value);

                        const internship = internshipData.find(
                          (item) => item.id === Number(value)
                        );

                        setSelectedInternship(internship || null);
                      }}
                    // style={{ marginBottom: "20px" }}
                    >
                      <option value="">-- Select Course --</option>
                      {internshipData.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.internship_topic}
                        </option>
                      ))}
                    </select>
                  </>
                )}


                {/* {internshipSource !== "COLLEGE" && ( */}

                {/* New code added */}
                {(internshipSource || savedInternship.internship_type) !== "COLLEGE" && (
                  <>
                    <div className="form-grid">

                      <div className="form-group">
                        <label>Internship Title<span className="errorclr">*</span></label>
                        <input
                          type="text"
                          name="title"
                          value={externalInternship.title}
                          onChange={handleExternalChange}
                        />
                      </div>

                      <div className="form-group">
                        <label>Internship Provider <span className="errorclr">*</span></label>

                        {/* IPO SELECT */}
                        {isIPO && (
                          <select
                            name="provider"
                            value={externalInternship.provider}
                            onChange={handleExternalChange}
                          >

                            <option value="">-- Select Provider --</option>
                            {getVendorData?.map((vendor) => (
                              <option key={vendor.id} value={vendor.id}>
                                {vendor.vendor_name}</option>
                            ))}
                            {/* <option value="ASAP">ASAP</option> */}
                          </select>
                        )}

                        {/* NOT LISTED INPUT */}
                        {!isIPO && (
                          <input
                            type="text"
                            name="provider"
                            value={externalInternship.provider_name}
                            //value={externalInternship.provider}
                            onChange={handleExternalChange}
                          />
                        )}
                      </div>
                      {/* Duration hide */}
                      {/* <div className="form-group">
                            <label>Duration (Months)<span className="errorclr">*</span></label>
                            <select
                              name="duration"
                              value={externalInternship.duration}
                              onChange={handleExternalChange}
                            >
                              <option value="">-- Select Duration --</option>
                              {[1,2,3,4,5,6].map(m => (
                                <option key={m} value={m}>{m} Month</option>
                              ))}
                            </select>
                          </div> */}

                      <div className="form-group">
                        <label>Mode of Internship<span className="errorclr">*</span></label>
                        <select
                          name="mode"
                          value={externalInternship.mode}
                          onChange={handleExternalChange}
                        >
                          <option value="">-- Select Mode --</option>
                          <option value="Online">Online</option>
                          <option value="Offline">Offline</option>
                          <option value="Hybrid">Hybrid</option>

                        </select>
                      </div>

                    </div>

                    <div className="form-group">
                      <label>Description</label>
                      <textarea
                        name="description"
                        value={externalInternship.description}
                        onChange={handleExternalChange}
                        rows={4}
                      />
                    </div>
                  </>
                )}

                <div className="actions actions-right">
                  <button
                    className="btn-secondary"
                    onClick={() => {
                      setShowUpdateMode(false);
                      setReload(!reload);
                    }}
                  >
                    Cancel
                  </button>

                  {internshipSource === "COLLEGE" ? (
                    <button
                      className="btn-primary"
                      onClick={() => setFirstSubmit(true)}
                      disabled={loading}
                    >
                      {loading ? "Updating..." : "Update"}
                    </button>
                  ) : (
                    <button
                      className="btn-primary"
                      onClick={() => setFirstSubmitData(true)}
                      disabled={loading}
                    >
                      {loading ? "Updating..." : "Update"}
                    </button>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
    );
  };

  return (
    <StudentTemplate>
      <ToastContainer />

      <div className="internship-section">
        <div className="card">
          <div className="internship-wrapper" style={{ width: '100%' }}>
            {/* SELECT COURSE - Only show if no saved internship or in update mode for new selection */}
            {!savedInternship && (
              <div className="card select-card">
                <h4>Select Internship Providing Organisation(IPO) </h4>

                {/* NEW FIRST SELECT */}


                <Select
                  styles={customStyles}
                  isDisabled={activeReadOnlyMode}
                  options={ipoOptions}
                  value={ipoOptions.find(opt => opt.value === internshipSource) || null}
                  onChange={(selectedOption) => {
                    const value = selectedOption?.value || "";

                    // ✅ KEEP YOUR ORIGINAL LOGIC EXACTLY
                    setInternshipSource(value);

                    if (value === "COLLEGE") {
                      setIsNotListed(false);
                      setIsIPO(false);
                    }

                    if (value === "IPO") {
                      setIsIPO(true);
                      setIsNotListed(true);
                      setSelectedInternship(null);
                    }

                    if (value === "NOT_LISTED") {
                      setIsNotListed(true);
                      setIsIPO(false);
                      setSelectedInternship(null);
                    }
                  }}
                  placeholder="--- Select ---"
                  isClearable
                />

                {/* RED WARNING MESSAGE */}
                {activeReadOnlyMode && activeReadOnlyMessage && (
                  <p style={{ color: "red", marginTop: "8px", fontWeight: "500" }}>
                    {activeReadOnlyMessage}
                  </p>
                )}

                <div className="m-t-10">
                  {/*  SHOW ONLY FOR COLLEGE */}
                  {internshipSource === "COLLEGE" && (
                    <>
                      <h4>Select Internship Topic </h4>

                      <Select
                        styles={customStyles}

                        isDisabled={isFormLocked}
                        value={
                          selectedCourse
                            ? internshipData
                              .map(formatOption)
                              .find((opt) => opt.value === Number(selectedCourse))
                            : null
                        }
                        onChange={(selectedOption) => {
                          const value = selectedOption?.value || "";
                          setSelectedCourse(value);

                          const internship = internshipData.find(
                            (item) => item.id === Number(value)
                          );

                          setSelectedInternship(internship || null);
                        }}
                        options={courseCode ? internshipData.map(formatOption) : []}
                        placeholder="-- Select Course --"
                        isClearable
                        //Option value last partstyling
                        formatOptionLabel={(option) => (
                          <div style={{ display: "flex", gap: "6px" }}>
                            <span>{option.topic}</span>
                            <span style={{ color: "#782849", fontWeight: 500 }}>
                              | {option.provider}
                            </span>
                          </div>
                        )}
                      />

                    </>
                  )}
                </div>

                {/* MESSAGE SHOWN ON PAGE LOAD */}
                {eventMessage && (
                  <p className={`event-msg ${isEventActive ? "active" : "closed"}`}>
                    {eventMessage}
                  </p>
                )}
              </div>
            )}

            {/* Show saved internship if exists */}
            {savedInternship && renderSavedInternship()}

            {/* Show new selection forms only if no saved internship */}
            {!savedInternship && selectedInternship && !isNotListed && getActiveEvents && (
              <div className="card details-card">
                <span className="badge">Discipline: {studentDisciplineName}</span>
                {courseCode && (
                  <span className="course-code-badge">
                    Course Code: {courseCode}-{courseName}
                  </span>
                )}

                <h3>{selectedInternship.internship_topic}</h3>

                <div className="row info-grid-bs">
                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Offered By</label>
                      <span>{selectedInternship.offered_by_name}</span>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Mode of Study</label>
                      <span>{selectedInternship.mode_of_study}</span>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Vendor Mobile</label>
                      <span>{selectedInternship.vendor_mobileno}</span>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Vendor Email</label>
                      <span className="break-word">
                        {selectedInternship.vendor_email}
                      </span>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="info-item">
                      <label>Vendor Address</label>
                      <span>{selectedInternship.vendor_address}</span>
                    </div>
                  </div>
                </div>

                <div className="actions actions-right">
                  <button className="btn-secondary"
                    onClick={() => cancelForm()}
                  >Cancel</button>
                  <button
                    className="btn-primary"
                    onClick={() => setFirstSubmit(true)}
                  >
                    Save
                  </button>
                </div>
              </div>
            )}

            {/* NOT LISTED FORM - Only show if no saved internship */}
            {/* IPO OR NOT LISTED */}
            {!savedInternship && (isNotListed || isIPO) && getActiveEvents && (
              <div className="card details-card">
                <h3>Internship Details</h3>
                {courseCode && (
                  <span className="course-code-badge" style={{ marginBottom: '15px', display: 'inline-block' }}>
                    Course Code: {courseCode}-{courseName}
                  </span>
                )}

                <div className="form-grid">
                  <div className="form-group">
                    <label>Internship Title <span className="errorclr">*</span></label>
                    <input
                      type="text"
                      name="title"
                      value={externalInternship.title}
                      onChange={handleExternalChange}
                    />
                  </div>

                  {/* <div className="form-group">
                  <label>Internship Provider <span className="errorclr">*</span></label>
                  <input
                    type="text"
                    name="provider"
                    value={externalInternship.provider}
                    onChange={handleExternalChange}
                  />
                </div> */}
                  <div className="form-group">
                    <label>
                      Internship Provider <span className="errorclr">*</span>
                    </label>

                    {/* IPO SELECT */}
                    {isIPO && (
                      <select
                        name="provider"
                        value={externalInternship.provider}
                        onChange={handleExternalChange}
                      >

                        <option value="">-- Select Provider --</option>
                        {getVendorData?.map((vendor) => (
                          <option key={vendor.id} value={vendor.id}>{vendor.vendor_name}</option>
                        ))}


                      </select>
                    )}

                    {/* TEXT INPUT FOR NOT LISTED */}
                    {!isIPO && (
                      <input
                        type="text"
                        name="provider"
                        value={externalInternship.provider}
                        onChange={handleExternalChange}
                        placeholder="Enter Internship Provider"
                      />
                    )}
                  </div>
                  {/* //Duration hide */}
                  {/* <div className="form-group">
                  <label>Duration (Months)<span className="errorclr">*</span></label>
                  <select
                    name="duration"
                    value={externalInternship.duration}
                    onChange={handleExternalChange}
                  >
                    <option value="">-- Select Duration --</option>
                    {[1, 2, 3, 4, 5, 6].map(m => (
                      <option key={m} value={m}>{m} Month</option>
                    ))}
                  </select>
                </div> */}

                  <div className="form-group">
                    <label>Mode of Internship <span className="errorclr">*</span></label>
                    <select
                      name="mode"
                      value={externalInternship.mode}
                      onChange={handleExternalChange}
                    >
                      <option value="">-- Select Mode --</option>
                      <option value="Online">Online</option>
                      <option value="Offline">Offline</option>
                      <option value="Hybrid">Hybrid</option>

                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    name="description"
                    value={externalInternship.description}
                    onChange={handleExternalChange}
                    rows={4}
                  />
                </div>

                <div className="actions actions-right">
                  <button className="btn-secondary"
                    onClick={() => cancelForm()}>
                    Cancel</button>
                  <button
                    className="btn-primary"
                    onClick={() => setFirstSubmitData(true)}
                  >
                    Save
                  </button>
                </div>
              </div>
            )}

            {/* Confirmation Modals */}
            {isFirstSubmit && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-body">
                      <div className="modal-toggle-wrapper">
                        <h4 className="text-center pb-2">
                          Confirm Internship {savedInternship ? 'Update' : 'Submission'}
                        </h4>

                        <p className="txt-aln-jst">
                          You are about to {savedInternship ? 'update your' : 'submit your'} internship application for
                          <strong> {selectedInternship?.internship_topic}</strong>.
                          {courseCode && <><br />Course Code: <strong>{courseCode}-{courseName}</strong></>}
                          <br />Please confirm to proceed.
                        </p>

                        <div className="d-flex justify-content-center mt-4">
                          <button
                            className="btn"
                            style={{
                              backgroundColor: "white",
                              borderColor: "red",
                              color: "black"
                            }}
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-danger mx-2"
                            onClick={handleFinalSubmit}
                            disabled={loading}
                          >
                            {loading ? "Saving..." : "Save"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isFirstSubmitExt && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-body">
                      <div className="modal-toggle-wrapper">
                        <h4 className="text-center pb-2">
                          Confirm Internship {savedInternship ? 'Update' : 'Submission'}
                        </h4>

                        <p className="txt-aln-jst">
                          You are about to {savedInternship ? 'update the' : 'submit the'} external internship&nbsp;
                          <strong> {externalInternship.title}</strong>.
                          {courseCode && <><br />Course Code: <strong>{courseCode}-{courseName}</strong></>}
                          <br />Please confirm to proceed.
                        </p>

                        <div className="d-flex justify-content-center mt-4">
                          <button
                            className="btn"
                            style={{
                              backgroundColor: "white",
                              borderColor: "red",
                              color: "black"
                            }}
                            onClick={handleCancelExt}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-danger mx-2"
                            onClick={handleFinalSubmitExt}
                            disabled={loading}
                          >
                            {loading ? "Saving..." : "Save"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </StudentTemplate>
  );
};

export default StudentInternship;
